<template>
  <div class="visitor-profile-mobile">
    <div class="visitor-profile-mobile-inner">
      <div class="visitor-profile-mobile-avatar-wrapper">
        <img
          class="visitor-profile-mobile-avatar"
          :src="userAvatar"
          :alt="getUserData('name')"
        >
      </div>
      <div class="visitor-profile-mobile-data">
        <h4>{{ getUserData('name') || $t('Agent') }}</h4>
        <p>{{ getUserData('companyDisplayName') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import defaultPersonaImage from '../img/default-persona.svg'

export default {
  name: 'VisitorProfileMobile',
  data () {
    return {
      defaultPersonaImage
    }
  },

  computed: {
    ...mapGetters([
      'user'
    ]),

    userAvatar () {
      if (this.user.showAdminProfile && this.user.adminProfile) {
        return this.user.adminProfile.profileUrl || this.defaultPersonaImage
      } else {
        return this.user.profileUrl || this.defaultPersonaImage
      }
    }
  },

  methods: {
    ...mapActions([
    ]),

    getUserData (key) {
      if (this.user.showAdminProfile && this.user.adminProfile) {
        return this.user.adminProfile[key] || ''
      } else {
        return this.user[key] || ''
      }
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
@import '~css/addon/main'
@import '~css/common/extends'

.visitor-profile-mobile {
  width: 100%;
  height: 14.43%;
  background-color: rgba(94, 94, 96, 0.7);
  padding-top: 2.5%;
  padding-left: 12px;
  padding-right: 12px;
}

.visitor-profile-mobile-inner {
  height: 100%;
  background-color: #24252a;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  align-items: center;
  padding-left: 14px;
  padding-right: 14px;
}

.visitor-profile-mobile-avatar-wrapper {
  height: 65%;
  margin-right: 8px;
}

.visitor-profile-mobile-avatar {
  height: 100%;
  border-radius: 50%;
  border-width: 1px;
  border-color: #f0f0f0;
  border-style: solid;
}

</style>
